<template>
  <b-link
    v-if="linkTo"
    :to="linkTo"
    router-tag="b-button"
    class="my-3 mehr-button shadow-sm"
  >
    <contentPart handle="moreButton" />
  </b-link>
</template>

<script>
import { mapGetters } from 'vuex'
import contentPart from '@/components/subparts/Content-part'

export default {
  props: {
    linkTo: String
  },
  name: 'mehrButton',
  data () {
    return {

    }
  },
  components: {
    contentPart
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      staticData: 'getStaticData',
      contentParts: 'getContentParts'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
